export default __webpack_public_path__ + "static/media/location.8b74aa52.png";